import log from 'loglevel'
import axios from 'axios'

/* eslint class-methods-use-this: ["off"] */

export default class CertificateStatus {
  constructor() {
    log.info('[INFO] Initialize Certificate Status Module')
  }

  fetchAllCertificateStatus(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params: {
          p: params.p,
          page_size: params.page_size,
          search: params.q,
        },
      }
    }

    return new Promise((resolve, reject) => {
      axios
        .get('v1/company/certificate/status/', parameters)
        .then(response => {
          log.debug('[DEBUG] Success to fetch certificate status')
          resolve(response.data)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch certificate status')
          log.error(error)
          reject(error.response)
        })
    })
  }

  fetchCertificateStatus(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/company/certificate/status/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch certificate status')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch certificate status')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updateCertificateStatus(id, data) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/company/certificate/status/${id}/`, data)
        .then(response => {
          log.debug('[DEBUG] Success to update certificate status')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update certificate status')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addCertificateStatus(data) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/company/certificate/status/', data)
        .then(response => {
          log.debug('[DEBUG] Success to add certificate status')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add certificate status')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deleteCertificateStatus(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/company/certificate/status/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete certificate status')
          resolve()
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete certificate status')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
